import React from 'react';
import { Field, FieldGrid, SectionCard } from '../../../../components/Section';
import { IDerayahOrderDetails } from '../../../../types/derayah';
import { DerayahStatusChip } from './DerayahStatusChip';
import { formatOptionalDateTime, formatRef, formatSar } from './format';

interface DerayahCashMovementProps {
  order: IDerayahOrderDetails;
}

/**
 * Subscriptions move cash to Derayah through a cash batch; redemptions receive
 * it back as an incoming transfer. Only the section relevant to the order type
 * is rendered, and nothing at all when that section has no data yet.
 */
export function DerayahCashMovement({ order }: DerayahCashMovementProps) {
  if (order.type === 'SUBSCRIPTION') {
    const { cashBatch } = order;

    if (!cashBatch) {
      return null;
    }

    return (
      <SectionCard title="Cash batch" sx={{ mt: '16px' }}>
        <FieldGrid columns={3}>
          <Field label="Batch status">
            <DerayahStatusChip status={cashBatch.status} />
          </Field>
          <Field label="Total transferred amount" value={formatSar(cashBatch.totalAmount)} />
          <Field label="ANB payment transfer ref" value={formatRef(cashBatch.paymentTransferId)} />
          <Field label="Derayah claimed transfer ref" value={formatRef(cashBatch.claimedTransferRef)} />
          <Field label="Batch created at" value={formatOptionalDateTime(cashBatch.batchCreatedAt)} />
        </FieldGrid>
      </SectionCard>
    );
  }

  const { incomingTransfer } = order;

  if (!incomingTransfer) {
    return null;
  }

  return (
    <SectionCard title="Incoming transfer" sx={{ mt: '16px' }}>
      <FieldGrid columns={3}>
        <Field label="Transfer status">
          <DerayahStatusChip status={incomingTransfer.status} />
        </Field>
        <Field label="Expected amount" value={formatSar(incomingTransfer.expectedAmount)} />
        <Field label="Received amount" value={formatSar(incomingTransfer.receivedAmount)} />
        <Field label="Derayah transfer trans. number" value={formatRef(order.transferTransNumber)} />
        <Field label="ANB transfer ref" value={formatRef(incomingTransfer.anbTransferId)} />
        <Field label="Confirmed at" value={formatOptionalDateTime(incomingTransfer.confirmedAt)} />
      </FieldGrid>
    </SectionCard>
  );
}
